<script>
export let player;

let parent_names = '';
if (player.guardian_first_name) {
	parent_names += player.guardian_first_name;
	if (player.guardian_last_name) {
		parent_names += ' ';
		parent_names += player.guardian_last_name;
	}
}
let player_name = player.first_name + ' ' + player.last_name;

let parent_emails = '';
if (player.guardian_email) {
	parent_emails = player.guardian_email;
}

let parent_phones = '';
if (player.parent_guardian_phone) {
	parent_phones = player.parent_guardian_phone;
}
// player.guardian_home_phone

</script>



<style>

.parent-thumb {

}

</style>



<div class="panel-block player-thumb">

	<div class="columns is-variable is-mobile is-2 is-vcentered">

		<div class="column is-3-desktop is-4-touch">
			<span>
				{parent_names}
			</span>
		</div>

		<div class="column is-3-desktop is-4-touch">
			<span>
				{parent_emails}
			</span>
		</div>

		<div class="column is-3-desktop is-4-touch">
			<span>
				{player_name}
			</span>
		</div>

		<div class="column is-3-desktop is-hidden-touch">
			<span>
				{parent_phones}
			</span>
		</div>

	</div>

</div>



